/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.16.0
 */

import { IPersonalDataConfirmTranslation } from '../../types';

export const initialPersonalDataConfirmTranslation: IPersonalDataConfirmTranslation = {
    step: {
        1: {
            link: {
                subscribers: '',
            },
            onlySubscribers: '',
        },
        2: {
            all: '',
        },
        3: {
            all: '',
        },
    },
    subtitle: '',
    text: {
        link: {
            subscribers: '',
        },
        onlySubscribers: '',
    },
    title: '',
};
